// extracted by mini-css-extract-plugin
module.exports = {"all__table":"index--all__table--cVEa8","row__role":"index--row__role--2K_kH"};